export default "__VITE_ASSET__10d5ffb4__"